export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return dateStr;
  }
};

export const formatMonth = (monthStr) => {
  const [year, month] = monthStr.split('-');
  const months = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[parseInt(month) - 1]} ${year.slice(2)}`;
};

export const getExpirationDate = (adhesion) => {
  if (adhesion.expiration_date) {
    return formatDate(adhesion.expiration_date);
  }
  const startDate = adhesion.start_date || adhesion.signed_at || adhesion.created_at || adhesion.date_creation;
  if (startDate) {
    try {
      const date = new Date(startDate);
      date.setFullYear(date.getFullYear() + 1);
      return formatDate(date.toISOString());
    } catch {
      return 'N/A';
    }
  }
  return 'N/A';
};
